/** 胸卡打印 / 导出：优先高清彩色 PNG */

import { downloadBadgeColorPng, renderBadgePrintImages } from '@/utils/badgeRenderPrint.js'

export { exportBadgeWord } from '@/utils/badgeExportWord.js'

const BODY_CLASS = 'badge-print-only'
const TARGET_CLASS = 'badge-print-target'

function waitImagesLoaded(doc) {
  const imgs = Array.from(doc.querySelectorAll('img'))
  return Promise.all(
    imgs.map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete && img.naturalWidth > 0) {
            resolve()
            return
          }
          img.onload = () => resolve()
          img.onerror = () => resolve()
        }),
    ),
  )
}

function ensureCanvasPrintStyles() {
  if (document.getElementById('badge-canvas-print-styles')) return
  const style = document.createElement('style')
  style.id = 'badge-canvas-print-styles'
  style.textContent = `
@page { size: landscape; margin: 8mm; }
@media print {
  html, body {
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
    color-scheme: light !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  .badge-canvas-print-root { margin: 0; padding: 0; }
  .badge-canvas-print-page {
    page-break-after: always;
    break-after: page;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 98vh;
    box-sizing: border-box;
  }
  .badge-canvas-print-page:last-child {
    page-break-after: auto;
    break-after: auto;
  }
  .badge-canvas-print-page img {
    display: block;
    max-width: 100%;
    max-height: 96vh;
    width: auto;
    height: auto;
    filter: none !important;
    -webkit-filter: none !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
  }
}
`
  document.head.appendChild(style)
}

async function printBadgeCanvas(card) {
  const { front, back } = await renderBadgePrintImages(card)
  const iframe = document.createElement('iframe')
  iframe.setAttribute('title', '胸卡打印')
  iframe.style.cssText = 'position:fixed;left:0;top:0;width:0;height:0;border:0;opacity:0'
  document.body.appendChild(iframe)
  const doc = iframe.contentWindow.document
  doc.open()
  doc.write(`<!DOCTYPE html><html><head><meta charset="UTF-8"/>
<title>胸卡打印</title>
<style>
html,body{margin:0;padding:0;background:#fff}
.badge-canvas-print-page{display:flex;align-items:center;justify-content:center;min-height:100vh}
.badge-canvas-print-page img{display:block;max-width:100%;max-height:96vh}
</style></head><body>
<div class="badge-canvas-print-root">
<div class="badge-canvas-print-page"><img id="f" alt="正面"/></div>
<div class="badge-canvas-print-page"><img id="b" alt="反面"/></div>
</div></body></html>`)
  doc.close()
  ensureCanvasPrintStyles()
  const styleEl = document.getElementById('badge-canvas-print-styles')
  if (styleEl) {
    doc.head.appendChild(styleEl.cloneNode(true))
  }
  doc.getElementById('f').src = front
  doc.getElementById('b').src = back
  await waitImagesLoaded(doc)
  await new Promise((r) => setTimeout(r, 200))
  const win = iframe.contentWindow
  const cleanup = () => {
    try {
      document.body.removeChild(iframe)
    } catch {
      /* ignore */
    }
    win.removeEventListener('afterprint', cleanup)
  }
  win.addEventListener('afterprint', cleanup)
  setTimeout(cleanup, 8000)
  win.focus()
  win.print()
}

function ensureDomPrintStyles() {
  if (document.getElementById('badge-print-styles')) return
  const style = document.createElement('style')
  style.id = 'badge-print-styles'
  style.textContent = `
@page { size: landscape; margin: 8mm; }
@media print {
  body.badge-print-only * { visibility: hidden !important; }
  body.badge-print-only .badge-print-target,
  body.badge-print-only .badge-print-target * {
    visibility: visible !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}
`
  document.head.appendChild(style)
}

/** 下载合图 PNG（仅便于预览颜色，不适合双面印） */
export async function exportBadgeColorPng(card) {
  if (!card || !card.available) {
    window.alert('请先确保胸卡预览正常后再导出')
    return
  }
  try {
    await downloadBadgeColorPng(card)
  } catch (e) {
    window.alert(e.message || '导出失败，请检查底图能否正常显示')
  }
}

/**
 * @param {string} elementId DOM 回退
 * @param {object|null} card
 */
export async function printBadgeArea(elementId, card) {
  if (card && card.available) {
    try {
      await printBadgeCanvas(card)
      return
    } catch (e) {
      console.warn('[badgePrint] canvas print failed', e)
      window.alert(
        (e.message || '彩色打印准备失败') +
          '\n\n请改用「下载彩色 PNG」导出后，用系统看图软件打印。',
      )
    }
  }
  const el = document.getElementById(elementId)
  if (!el) {
    window.alert('无法打印：未找到胸卡预览区域')
    return
  }
  if (!el.classList.contains(TARGET_CLASS)) {
    el.classList.add(TARGET_CLASS)
  }
  ensureDomPrintStyles()
  document.body.classList.add(BODY_CLASS)
  const cleanup = () => document.body.classList.remove(BODY_CLASS)
  window.addEventListener('afterprint', cleanup, { once: true })
  setTimeout(cleanup, 3000)
  window.print()
}
